import React, { useEffect, useState, useRef } from 'react';
import Loader from '../../../../CustomComponents/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS_SUCCESS_CODE,CANCEL_UPCOMING_TRANSACTION, GET_CLIMB_FEATURES, } from '../../../../../network/URLConstants';
import HomeHeader from '../../../../CustomComponents/HomeHeader';
import DynamicCard from '../../../../CustomComponents/DynamicCard';
import { width } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomAlertModel from '../../../../CustomComponents/CustomAlertModel';
import { withOidcSecure, useOidcUser, useOidcAccessToken, useOidc } from '@axa-fr/react-oidc'
import moment from 'moment';
import TermsArrow from '../../../../../assets/images/terms_arrow.png';
import left_arrow_green from '../../../../../assets/images/left_arrow_green.png';
import report_a_problem_flag from '../../../../../assets/images/report_a_problem_flag.png';
import { addLineBreaks, retrieveData } from '../../../../../utils';
import { appTheme } from '../../../../../helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../../../network/NetworkUtils';
import HomeLayout from '../../../../Layout/HomeLayout';
import { getUserMembership } from '../../../../../helpers/utils/Utils';



const CbkPlusTransactionCard = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentDate = new Date();
  const minDate = new Date(currentDate);
  minDate.setMonth(currentDate.getMonth() - 6); // Minimum date is 6 months ago
  const { t } = useTranslation(); // Hook to access translation functions
  const cards = useSelector(state => JSON.parse(state.userCards));
  const transactionDetails = useSelector(state => JSON.parse(state.cancelTransactionDetails));
  const selectedItem = cards?.[0]
  const [isLoading, setIsLoading] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro text-[var(--modal-text-heading-clr)] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const styleAll = `font-hanken-grotesk  lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const styleAllgradient = `font-hanken-grotesk  lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [modelImage, setModelImage] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [btn1Focus, setBtn1Focus] = useState(false);
  const [btn2Focus, setBtn2Focus] = useState(false);
  const SelectedCardDetails = useSelector(state => state.selectedCardDetails);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [cardDetails, setCardDetails] = useState({})
  const isMobile = window.innerWidth < 768
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const cbkTransactionDetailsData = useSelector(state => state.cbkTransactionDetails);
  const appThemeData = appTheme(kudzuPlusTrue)
  const {DrCrIndicator,TransactionTypeCode} = cbkTransactionDetailsData;
  const prefix = DrCrIndicator === "Cr" ? "+ " : "- ";
  const isPrimrayKey = cards !== null ? cards !== null ? cards[0].CardKey : 0 : 0;
  const accessToken = useSelector(state => state.accessToken);
  const climbFeatures = useSelector(state => state.climbFeatures);
   const accessTokenToApi = useSelector((state) => state.accessToken);
   const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
   const userMembershipData = getUserMembership(loggedResponse)
    
  const transactionType = TransactionTypeCode === 'PMMM' ? true : false
  //PMMM code means resolved transactions
  
//   useEffect(()=>{
// alert(JSON.stringify(cbkTransactionDetailsData));
//   },[cbkTransactionDetailsData])


const handleTermsClick = () =>{
  if (accessTokenToApi === undefined || accessTokenToApi == null) {
    return;
}
else {
    navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
      url:
      userMembershipData?.membershipType === "Plus" ||
      userMembershipData?.membershipType === "Trial"
      ? "CoveredByKudzuPlusTerms"
      : "CoveredByKudzuTerms"
      , accType: 64, CardKey: cards?.[0]?.CardKey } });

}
}


  useEffect(() => {
    if (SelectedCardDetails != null) { }
  }, [SelectedCardDetails, cardDetails])

  const closeModel = () => {
    setShowModel(false);
  }


  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, btn1Focus, btn2Focus, isBorderNone) => {
    // setshowErrorImg(showErrorImg)
    // setisBorderNone(isBorderNone)
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setFooterMsg(footerMsg)
    setBtn1Focus(btn1Focus)
    setBtn2Focus(btn2Focus)
    setisBorderNone(isBorderNone)
  }
  const onCancelBtnClick = () => {
     
  }
  const onAcptBtnClick = () => {
   
  }

  const addMoneyClick = () => {
    navigate('/AccountServices/Spending/TransferMoney') 
  }

  const manageCbkClick = async () => {
    debugger;
    if (isPrimrayKey == undefined || isPrimrayKey == null) {
      return
    }
    else if (climbFeatures) {
      navigate('/Climb/ManageCoveredByKudzu')
    }
    else {
      setIsLoading(true);
      const deviceId = await retrieveData('updatedDeviceId')
      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', isPrimrayKey)
      const response = await GetRequest(url, headers);
      const responseJson = JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
        setIsLoading(false);
        navigate('/Climb/ManageCoveredByKudzu')
      } else {
        return [];
      }
    }
  }

  const handleReportAProblem=()=>{
    showAlertModal(true, isMobile ? t("need_to") : '', isMobile ? t("we_r_here_to_help") : addLineBreaks(t("need_to_here_to_help")), <p>{t("call")} <span className='font-[600px] text-[var(--modal-text-highlight)]'>{t('1-855-751-0025')}</span> {t('to_report')} <span className='font-[600px] text-[var(--modal-text-highlight)] cursor-pointer pointer-events-auto' onClick={()=>navigate('/Help/ContactUs')} >{t('customer_care')}</span> {t('team_to_help')}</p>, true, true, t('back_to_account'), t('cancel'), true, require('../../../../../assets/images/illo-report.png'), '', false, true, true)

  }
  const getHeaderText = () => {
    return (
      <>
        {(addLineBreaks(t('here_are_details_for_scheduled_transfer')))}
      </>
    )
  };

  return (
    <div>
      <>
        <HomeLayout>
          <>
            <HomeHeader heading={
              <>
                <div className='flex sm:hidden'>
                  <div onClick={() => {
                    dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('UpcomingTab') } });
                    navigate(-1);
                  }} className='mb-5 text-[14px] cursor-pointer font-[600] font-hanken-grotesk flex items-center'>
                    <img src={left_arrow_green} alt='leftArrow' className='mr-1' />
                    <span className='text-[#559C7E]'>{t('back')}</span>
                  </div>
                </div>
                {getHeaderText()}
              </>

            } isHeaderCaption={true} />
          </>
          <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
          animate__animated animate__fadeInRight '>
            <DynamicCard
              header={false}
              footer={true}
              CardRadius={true}
              cardWidth={width.homeCard}
              HeaderRadius={true}
              backgroundColor={'--cardHeading-bg'} 
              // isWhite={true}
              isWhite={appThemeData.isWhiteBgForCard}
              isDarkForKudzu={appThemeData.isDarkBgForCard}
              HeaderContent={
                <div className='sm:block hidden'>
                  <div className='sm:flex block justify-between flex-nowrap items-center md:my-[47px] sm:my-[25px] my-[20px] md:mx-[4%] sm:ml-[6%] sm:mr-[8%] mr-[2.5rem] ml-[2.5rem] cursor-pointer'>
                    <div onClick={() => {
                      dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('UpcomingTab') } });
                      navigate(-1);
                    }} className='lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px]  cursor-pointer text-[var(--text-clr-transactions)] font-[500] md:font-[500] font-hanken-grotesk flex items-center'>
                      <img src={TermsArrow} alt='leftArrow' style={{ filter: 'brightness(0) invert(1)' }} className='mr-1' />
                      <span>{t('spending')}</span>
                    </div>
                  </div>
                </div>
              } >

              <div className='md:pb-[9rem] pb-[5rem] mt-6 sm:px-0 px-4'>
                {/* Transactions */}
                <div className='mb-10'>
                  <p className='font-hanken-grotesk text-[var(--primary-text-cards)]
                     uppercase lg:text-[13px] md:text-[13px] sm:text-[13px] text-[10px]
                      font-[600] tracking-[2px]'>{t('transactions')}</p>
                </div>
                <div className='flex flex-row sm:items-center justify-between w-full'>
                  <div className='md:w-[10%] sm:w-[20%]'>
                    <img src={cbkTransactionDetailsData?.IconUri} alt="Icon" className='lg:h-[44px] md:w-[38px] md:h-[38px] sm:h-[30px] sm:w-[30px] h-[40px] w-[40px] lg:w-[44px]' />
                  </div>
                  <div className={`lg:w-1/4 md:w-[30%] sm:w-1/2 w-[57%] ${styleAll} `}>
                    <p>{cbkTransactionDetailsData?.Description}</p>
                    <p className='block sm:hidden font-hanken-grotesk text-[#262B3A] lg:text-[13px] md:text-[13px] sm:text-[13px] text-[14px] font-[400] mt-1 opacity-[50%]'>{moment(cbkTransactionDetailsData?.TransactionDate).format('MMM DD')}</p>
                  </div>
                  <div className={`hidden sm:block sm:w-1/4 text-center ${styleAll}`}>
                    <p>{moment(cbkTransactionDetailsData?.TransactionDate).format('MMM DD')}</p>
                  </div>
                  <div className={`sm:w-1/5`}>
                    <p className={`flex justify-end mb-8 sm:mb-0 font-hanken-grotesk lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words ${kudzuPlusTrue && transactionType  ? 'text-[#30BC89]' : 'text-[var(--text-clr-transactions)]' }`}
                    >{prefix}{parseInt(cbkTransactionDetailsData?.Amount)}.{(Math.abs(cbkTransactionDetailsData?.Amount) % 1).toFixed(2).slice(2)}</p>
                  </div>
                </div>
                <div className='border-b-[2.5px] opacity-50 border-[var(--transactions-acc-number-border)] mt-6'></div>

                <div class="flex justify-center flex-col items-center">

                  <div class="md:w-[75%] w-full sm:mt-14 mt-8">
                    <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('from')}</p>
                    <p className={`${styleAll}`}>{cbkTransactionDetailsData?.From}</p>
                  </div>

                  <div class="sm:flex md:w-[75%] w-full sm:mt-14 mt-8">
                    <div className='sm:w-[70%]'>
                      <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('merchant')}</p>
                      <p className={`mb-8 sm:mb-0 ${styleAll}`}>{cbkTransactionDetailsData?.Description}</p>
                    </div>
                    <div className='sm:w-[30%]'>
                      <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('amount')}</p>
                      <p className={`mb-8 sm:mb-0 font-hanken-grotesk lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words ${kudzuPlusTrue && !transactionType  ? 'text-[#30BC89]': 'text-[var(--text-clr-transactions)]' }`}
                      >{prefix}{ parseInt(cbkTransactionDetailsData?.Amount)}.{(Math.abs(cbkTransactionDetailsData?.Amount) % 1).toFixed(2).slice(2)}</p>
                    </div>
                  </div>
                  {cbkTransactionDetailsData?.FrequencyCode != "OT" ?
                    <>
                      <div class="sm:flex md:w-[75%] w-full sm:mt-14">
                        <div className='sm:w-[70%]'>
                          <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('date')}</p>
                          <p className={`mb-8 sm:mb-0 ${styleAll}`}>{moment(cbkTransactionDetailsData?.StartDate).format("MMMM DD, YYYY") || 'Not Specified'}</p>
                        </div>
                        {/* <div className='sm:w-[30%]'>
                          <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('end_date')}</p>
                          <p className={`mb-8 sm:mb-0 ${styleAll}`}>{cbkTransactionDetailsData?.EndDate == "Not Specified" ? cbkTransactionDetailsData?.EndDate : moment(cbkTransactionDetailsData?.EndDate).format('DD-MM-YYYY')}</p>
                        </div> */}
                      </div>

                      {/* <div class="sm:flex md:w-[75%] w-full sm:mt-14">
                        <div className='sm:w-[70%]'>
                          <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('remaining_payments')}</p>
                          <p className={`mb-8 sm:mb-0 ${styleAll}`}>{cbkTransactionDetailsData?.PaymentsRemaining}</p>
                        </div>
                        <div className='sm:w-[30%]'>
                          <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('frequency')}</p>
                          <p className={`mb-8 sm:mb-0 ${styleAll}`}>{cbkTransactionDetailsData?.FrequencyValue}</p>
                        </div>
                      </div> */}
                    </>
                    :
                    <>
                      <div class="sm:flex md:w-[75%] w-full sm:mt-14">
                        <div className='sm:w-[70%]'>
                          <p className='mb-8 font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('transfer_date')}</p>
                          <p className={`mb-8 sm:mb-0 ${styleAll}`}>{moment(cbkTransactionDetailsData?.StartDate).format('DD-MM-YYYY') || 'Not Specified'}</p>
                        </div>
                        <div className='sm:w-[30%]'>
                          <div className="  flex flex-row cursor-pointer items-center pt-10" onClick={() => { handleReportAProblem() }}>
                            <img onClick={() => { handleReportAProblem() }} src={appThemeData.report_a_problem_icon} className='w-[10px] h-[12px] sm:w-[11px] sm:h-[14px] mr-3' alt="arrow" />
                            <p className="font-hanken-grotesk text-[14px] leading-[14px] sm:font-[700] sm:text-[12px] sm:leading-[20px] font-[600] md:text-[16px] md:leading-[24px] text-secondary-2"
                              tabIndex={0}
                              onClick={() => { handleReportAProblem() }}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  handleReportAProblem()
                                }
                              }}
                            >{t('report_a_problem')}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  }

                  <div class="md:w-[75%] w-full sm:mt-14 mt-2">
                      <>
                        <div className="  flex flex-row cursor-pointer items-center mb-5" onClick={() => { handleReportAProblem() }}>
                          <img onClick={() => { handleReportAProblem() }} src={appThemeData.report_a_problem_icon} className='w-[10px] h-[12px] sm:w-[11px] sm:h-[14px] mr-3' alt="arrow" />
                          <p className="font-hanken-grotesk text-[14px] leading-[14px] sm:font-[700] sm:text-[12px] sm:leading-[20px] font-[600] md:text-[16px] md:leading-[24px] text-[var(--report-problem-text)]"
                            tabIndex={0}
                            onClick={() => { handleReportAProblem() }}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                event.preventDefault();
                                handleReportAProblem()
                              }
                            }}
                          >{t('report_a_problem')}</p>
                        </div>
                        {/* added new content */}
                      <p className='mt-9 sm:my-9  text-[15px] font-hanken-grotesk 
                                                    leading-[18px] font-[400] sm:w-[500px] text-[#779CE5]'>
                        {t('cbk_transaction_updated_text_update')}
                        <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('Redirect_terms_and_conditions_cbk')}</span>{t('Remaining_content_cbk')}
                      </p>
                        <button
                          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); addMoneyClick() } }}
                          className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--cbk-transaction-bt-clr)]`}
                          onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); addMoneyClick() }}>
                          {t('addMoneyTittle')}
                        </button>
                        {kudzuPlusTrue && <button
                          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); manageCbkClick() } }}
                          className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--cbk-transaction-bt-clr)]`}
                          onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); manageCbkClick() }}>
                          {t('view_cbk+')}
                        </button>}
                      </>
                    {/* {cbkTransactionDetailsData?.FrequencyCode != "OT" ?
                      <>
                        <div className="  flex flex-row cursor-pointer items-center mb-5" onClick={() => { handleReportAProblem() }}>
                          <img onClick={() => { handleReportAProblem() }} src={report_a_problem_flag} className='w-[10px] h-[12px] sm:w-[11px] sm:h-[14px] mr-3' alt="arrow" />
                          <p className="font-hanken-grotesk text-[14px] leading-[14px] sm:font-[700] sm:text-[12px] sm:leading-[20px] font-[600] md:text-[16px] md:leading-[24px] text-[var(--text-clr-transactions)]"
                            tabIndex={0}
                            onClick={() => { handleReportAProblem() }}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                event.preventDefault();
                                handleReportAProblem()
                              }
                            }}
                          >{t('report_a_problem')}</p>
                        </div>
                        <button
                          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); onCancelClick(t('cancel_next_transfer')) } }}
                          className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                          onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); onCancelClick(t('cancel_next_transfer')) }}>
                          {t('cancel_next_transfer')}
                        </button>
                        <button
                          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); onCancelClick(t('cancel_series')) } }}
                          className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                          onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); onCancelClick(t('cancel_series')) }}>
                          {t('cancel_series')}
                        </button>
                      </> :
                      <button
                        onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); onCancelClick(t('cancel_transfer')) } }}
                        className={`w-full mt-2 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                        onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); onCancelClick(t('cancel_transfer')) }}>
                        {t('cancel_transfer')}
                      </button>} */}
                  </div>

                </div>
              </div>

            </DynamicCard>
          </div>
        </HomeLayout>
      </>
      <>
        {showModel &&
          <CustomAlertModel
            isOpen={showModel}
            onClose={closeModel}
            image={modelImage}
            highlightMsg={isMobile ? <span className={HighlightMsgStyles}>{highlightMsg}</span> : <p className={HighlightMsgStyles}>{highlightMsg}</p>}
            HeaderMsg={isMobile ? <span className={HeaderMsgStyles}>{headerMsg}</span> : <p className={HeaderMsgStyles}>{headerMsg}</p>}
            subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
            btn1Exists={btn1Exists}
            btn2Exists={btn2Exists}
            btn1Text={btn1Text}
            btn2Text={btn2Text}
            btn1TypeAcpt={btn1TypeAcpt}
            footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
            onAcptBtnClick={onAcptBtnClick}
            onCancelBtnClick={onCancelBtnClick}
            // showErrorImg={showErrorImg}
            isBorderNone={isBorderNone}
            btn1Focus={btn1Focus}
            btn2Focus={btn2Focus}
          />
        }
      </>
      {isLoading && <Loader />}
    </div >
  );
};

export default withOidcSecure(CbkPlusTransactionCard);
